import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ConfigProvider } from 'antd';
import Landing from './Pages/Landing';
import Login from './Pages/Login';
import ForgotPassword from './Pages/ForgotPassword';
import Dashboard from './Pages/Dashboard';
import Banner from './Pages/Banner';
import DashboardSuper from './SuperAdmin/Dashboard';
import Drivers from './Pages/Drivers';
import Warehouse from './Pages/Warehouse';
import Setting from './Pages/Setting';
import Orders from './Pages/Orders';
import OrderDetails from './Pages/Orders/OrderDetails';
import ApiDocumentation from './Pages/ApiDocumentation';
import Plans from './SuperAdmin/Plans';
import CreatePlan from './SuperAdmin/Plans/CreatePlan';
import EditPlan from './SuperAdmin/Plans/EditPlan';
import SelectPlan from './Pages/Plans/SelectPlan';
import StoreDetails from './SuperAdmin/StoreDetails';
import CustomNotifications from './Pages/Notifications/CustomNotifications';
import LiveTracking from './Pages/LiveTracking';
import CustomerLiveMap from './Pages/CustomerLiveMap';
import UserGuide from './Pages/UserGuide';
import Staff from './Pages/Staff';
import SupportTickets from './Pages/Support';
import { ToastContainer } from 'react-toastify';
import AuthMiddleware from './components/AuthMiddleware';
import PlanGuard from './components/PlanGuard';
import { routes } from './utils/routes.config';
import { useSelector } from 'react-redux';
import NotFound from './components/NotFound';
import { corporateTheme } from './config/theme';

function App() {
  const userDetail = useSelector((state: any) => state.UserData.userData);
  const isAuthenticated = userDetail?.role ? true : false;

  const isSuperAdmin = userDetail?.role === "superAdmin";

  return (
    <ConfigProvider theme={corporateTheme}>
      <ToastContainer />
      <BrowserRouter>
        <PlanGuard>
        <Routes>
          {/* ✅ Public Routes */}
          <Route path={routes.HOME} element={<Landing />} />
          <Route path={routes.LOGIN} element={isAuthenticated ? <Navigate to={isSuperAdmin ? routes.SUPER_DASHBOARD : routes.DASHBOARD} replace /> : <Login />} />
          <Route path={routes.FORGOT_PASSWORD} element={<ForgotPassword />} />
          <Route path="/live-map" element={<CustomerLiveMap />} />

          {/* 🔒 Protected Routes - Accessible only when logged in */}
          {isAuthenticated ? (
            <>

              {/* 🛡️ Super Admin Routes */}
              {isSuperAdmin && (
                <>
                  <Route path={routes.SUPER_DASHBOARD} element={<AuthMiddleware><DashboardSuper /></AuthMiddleware>} />
                  <Route path={routes.Orders} element={<AuthMiddleware><Orders /></AuthMiddleware>} />
                  <Route path="/Orders/:id" element={<AuthMiddleware><OrderDetails /></AuthMiddleware>} />
                  <Route path={routes.SETTINGS} element={<AuthMiddleware><Setting /></AuthMiddleware>} />
                  <Route path={routes.PLANS} element={<AuthMiddleware><Plans /></AuthMiddleware>} />
                  <Route path={routes.PLAN_CREATE} element={<AuthMiddleware><CreatePlan /></AuthMiddleware>} />
                  <Route path="/admin/plans/edit/:id" element={<AuthMiddleware><EditPlan /></AuthMiddleware>} />
                  <Route path="/admin/stores/:id" element={<AuthMiddleware><StoreDetails /></AuthMiddleware>} />
                  <Route path={routes.CUSTOM_NOTIFICATIONS} element={<AuthMiddleware><CustomNotifications /></AuthMiddleware>} />
                  <Route path={routes.SUPPORT} element={<AuthMiddleware><SupportTickets /></AuthMiddleware>} />
                  <Route path={routes.API_DOCUMENTATION} element={<AuthMiddleware><ApiDocumentation /></AuthMiddleware>} />
                  <Route path={routes.USER_GUIDE} element={<AuthMiddleware><UserGuide /></AuthMiddleware>} />
                  <Route path={routes.STAFF} element={<AuthMiddleware><Staff /></AuthMiddleware>} />
                </>
              )}

              {/* 🛡️ Admin Routes */}
              {!isSuperAdmin && (
                <>
                  <Route path={routes.DASHBOARD} element={<AuthMiddleware><Dashboard /></AuthMiddleware>} />
                  <Route path={routes.BANNER} element={<AuthMiddleware><Banner /></AuthMiddleware>} />
                  <Route path={routes.Drivers} element={<AuthMiddleware><Drivers /></AuthMiddleware>} />
                  <Route path={routes.Warehouse} element={<AuthMiddleware><Warehouse /></AuthMiddleware>} />
                  <Route path={routes.Orders} element={<AuthMiddleware><Orders /></AuthMiddleware>} />
                  <Route path="/Orders/:id" element={<AuthMiddleware><OrderDetails /></AuthMiddleware>} />
                  <Route path={routes.SETTINGS} element={<AuthMiddleware><Setting /></AuthMiddleware>} />
                  <Route path={routes.SELECT_PLAN} element={<AuthMiddleware><SelectPlan /></AuthMiddleware>} />
                  <Route path={routes.CUSTOM_NOTIFICATIONS} element={<AuthMiddleware><CustomNotifications /></AuthMiddleware>} />
                  <Route path={routes.SUPPORT} element={<AuthMiddleware><SupportTickets /></AuthMiddleware>} />
                  <Route path={routes.API_DOCUMENTATION} element={<AuthMiddleware><ApiDocumentation /></AuthMiddleware>} />
                  <Route path={routes.LIVE_TRACKING} element={<AuthMiddleware><LiveTracking /></AuthMiddleware>} />
                  <Route path={routes.USER_GUIDE} element={<AuthMiddleware><UserGuide /></AuthMiddleware>} />
                  <Route path={routes.STAFF} element={<AuthMiddleware><Staff /></AuthMiddleware>} />
                </>
              )}

              <Route path="*" element={<NotFound />} />

            </>
          ) : (
            // Redirect all unauthenticated access to login
            <Route path="*" element={<Navigate to={routes.LOGIN} replace />} />
          )}
        </Routes>
        </PlanGuard>
      </BrowserRouter>
    </ConfigProvider>
  );
}

export default App;
